import React from 'react';
import PropTypes from 'prop-types';

import { SuiModal, SuiModalContent, SuiModalFooter, SuiContainer, SuiButton } from '@splashthat/sui';

import { Headline, Subheadline } from 'common/components/Typography';

import './styles.styl';

const baseClassName = 'UpsellModal';

const UpsellModal = (props) => {
    // If we receive an object for the image source, we want to use the srcSet prop
    const imgSrc =
        typeof props.illustrationSource === 'string'
            ? { src: props.illustrationSource }
            : {
                  srcSet: `${props.illustrationSource.x1}, ${props.illustrationSource.x2} x2`,
              };

    return (
        <SuiModal onRequestClose={props.onRequestClose} open={props.open} heightMatchContent size="thin">
            <SuiContainer variation="border standard" className={baseClassName}>
                <SuiModalContent variation="padded">
                    <Headline tag="h2">{props.headline}</Headline>
                    <Subheadline tag="p">{props.text}</Subheadline>
                    <img {...imgSrc} alt={props.illustrationDescription} />
                </SuiModalContent>
                <SuiModalFooter variation="padded">
                    <SuiButton label={props.buttonLabel} href={props.buttonLink} target="_blank" size="small" />
                </SuiModalFooter>
            </SuiContainer>
        </SuiModal>
    );
};

const illustrationPropShape = {
    x1: PropTypes.string.isRequired,
    x2: PropTypes.string.isRequired,
};

UpsellModal.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    headline: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    buttonLink: PropTypes.string.isRequired,
    illustrationSource: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(illustrationPropShape)]).isRequired,
    illustrationDescription: PropTypes.string.isRequired,
    open: PropTypes.bool,
};

UpsellModal.defaultProps = {
    open: true,
};

export default UpsellModal;
